import { render, staticRenderFns } from "./performancePage.vue?vue&type=template&id=b09a62ae&scoped=true"
import script from "./performancePage.vue?vue&type=script&lang=js"
export * from "./performancePage.vue?vue&type=script&lang=js"
import style0 from "./performancePage.vue?vue&type=style&index=0&id=b09a62ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09a62ae",
  null
  
)

export default component.exports